export const STEPS = ["Calcola", "Personalizza", "Dati Personali"];

export const INITIAL_VITA_GARANZIE = {
  decesso: {
    enabled: true,
    durata: 10,
    capitale: 100000,
  },
  invalidita: {
    enabled: false,
    durata: 10,
    capitale: 100000,
  },
  malattiaGrave: {
    enabled: false,
    durata: 10,
    capitale: 5000,
  },
  inabilita: {
    enabled: false,
    durata: 10,
    capitale: 1000,
  },
};

export const INITIAL_FORM_DATA = {
  nome: "",
  cognome: "",
  email: "",
  telefono: "",
  codiceFiscale: "",
  dataNascita: "",
  privacyAccettata: false,
};

export const INITIAL_ERRORS = {
  nome: false,
  cognome: false,
  email: false,
  telefono: false,
  dataNascita: false,
  privacyAccettata: false,
};

export const GARANZIE_PREZZI = {
  decesso: 180,
  invalidita: 25,
  malattiaGrave: 86,
  inabilita: 28,
};

export const GARANZIE_CONFIG = [
  {
    key: "decesso",
    title: "Decesso",
    description: "Capitale assicurato ai tuoi cari",
    isPrimary: true,
  },
  {
    key: "invalidita",
    title: "Invalidità Totale Permanente",
    description: "Capitale uguale al decesso",
    isPrimary: false,
  },
  {
    key: "malattiaGrave",
    title: "Malattia Grave",
    description: "Capitale variabile in base al decesso",
    isPrimary: false,
  },
  {
    key: "inabilita",
    title: "Inabilità Totale Temporanea",
    description: "Capitale pari all'1% del decesso",
    isPrimary: false,
  },
];

export const FEATURES = [
  "Premio fisso per tutta la durata",
  "Fino a 300.000€ di capitale",
  "Sottoscrizione online fino a 54 anni",
];
